import Vue from 'vue'
// 在 Vue 上挂载一个指令 preventReClick
// Vue 防止按钮重复点击
const preventReClick = Vue.directive('preventReClick', {
  inserted(el, binding) {
    const debounceTimeout = binding.value || 3000;
    let timeout;
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;
        // 添加 debounce 函数，防止连续点击
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          el.disabled = false;
        }, debounceTimeout);
      }
    });
  }
});

export { preventReClick }


// WEBPACK FOOTER //
// ./src/mixin/preventReClick.js